import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { cleanApiClient } from "../services/apiClient"; // 💡 Import your clean instance
import { apiUrls } from "../config/apiUrls.const";
import { removeSecureItem, setSecureItem } from "../utils/LocalStorageManager";

const DirectLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const token = query.get("token");
  const bizCode = query.get("biz_code");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const processLogin = async () => {
      try {
        // Clear old footprints completely
        removeSecureItem("access_token");
        removeSecureItem("refresh_token");
        removeSecureItem("user");
        removeSecureItem("binfo");

        if (!token || !bizCode) {
          setError("Missing token or business code.");
          setLoading(false);
          return;
        }

        // 💡 Run through cleanApiClient to keep proper CORS headers while bypassing interceptors
        try {
          await cleanApiClient.post(apiUrls.logout, {}, {
            headers: { Authorization: `Bearer ${token}` }
          });
        } catch {
          // ignore logout errors on stale context states
        }

        // 💡 Request verification payload smoothly
        // 💡 FIX 2: Parse parameters directly from response.data based on your API response design
        const response = await cleanApiClient.post(
          apiUrls.checkBusinessUser,
          { biz_code: bizCode, token: token },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        console.log("Direct Login Verification Payload:", response);

        if (response?.data?.success) {
          // Access fields safely using the verified payload layout
          const payload = response.data.data; 
          const business = payload?.business;
          const user = payload?.user;
          
          // Pull variables straight from the structural endpoint layout token fields
          const accessToken = payload?.token?.access_token;
          const refreshToken = payload?.token?.refresh_token;

          if (!accessToken) {
            throw new Error("Missing valid access token signature.");
          }

          // Save tokens precisely using keys your modern apiClient checks for
          setSecureItem("access_token", accessToken);
          if (refreshToken) {
            setSecureItem("refresh_token", refreshToken);
          }
          
          setSecureItem("user", user);
          setSecureItem("binfo", [business]);

          // Boot directly into your functional workspace dashboard layout
          window.location.href = "/dashboard";
        } else {
          setError("Invalid login attempt.");
          setLoading(false);
        }
      } catch (err) {
        console.error("Direct login failed", err);
        setError("Unable to login. Please try again.");
        setLoading(false);
      }
    };

    processLogin();
  }, [token, bizCode, navigate]);

  return (
    <div className="container mt-5 text-center">
      {loading && <p>🔄 Logging you in to the selected business...</p>}
      {error && <p className="text-danger">{error}</p>}
    </div>
  );
};

export default DirectLogin;